export { getStaticProps, default } from 'components/pages/EventsFormPage'
